
import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { initClient } from '../../../api';
import { blobDownload } from '../../../util';
import { CellClient, CellList, CellQrLabelOption } from '../../backend/backendapi';
import CellQrLabelOptionSelector from './PrintModal/CellQrLabelOptionSelector';

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    CellQrLabelOptionSelector,
  },
})
export default class PrintModal extends Vue {
  @Prop({ required: true })
  readonly cells!: CellList[];

  readonly cellAPI = initClient(CellClient);
  printQrFormat: number = 1;
  printLabel1: CellQrLabelOption | null = CellQrLabelOption.Name;
  printLabel2: CellQrLabelOption | null = CellQrLabelOption.Ident;

  public open(): void {
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  generateQR(): void {//printSelected
    if (this.cells.length == 0) {
      return;
    }
    console.log('print qr' + JSON.stringify(this.cells));
    this.cellAPI.generateQRCodes(this.printQrFormat, this.printLabel1 ?? undefined, this.printLabel2 ?? undefined, this.cells)
        .then(response => response.data)
        .then(blob => blobDownload(blob, 'qrcode.pdf'));
  }

  generateNfc(): void {//printSelected
    if (this.cells.length == 0) {
      return;
    }
    console.log('print nfc' + JSON.stringify(this.cells));
    this.cellAPI.generateNFCCodes(this.cells)
        .then(response => response.data)
        .then(blob => blobDownload(blob, 'nfccode.txt'));
  }
}
